import React from 'react';

import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import {
  CommonOnUpdate, CommonOnError, CommonRequired, CommonScrollIntoView
} from 'types/props';
import BranchCollection from 'components/Form/BranchCollection';
import { i18n } from 'config/locales';
import SubsequentContactItem from './SubsequentContactItem';

interface Props extends ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  scrollIntoView?: CommonScrollIntoView
  attribute: string
}

export default class SubsequentContacts extends ValidationElement<Props> {
  updateList = (values) => {
    this.props.onUpdate({
      ...values,
    });
  };

  render() {
    const attribute = `${this.props.attribute}`;

    return (
      <div className="foreign-business-contact-subsequentcontacts">
        <BranchCollection
          label={i18n.t('foreign.business.contact.heading.hassubsequent')}
          appendLabel={i18n.t('foreign.business.contact.heading.hassubsequent2')}
          help="foreign.business.contact.help.hassubsequent"
          className="has-foreign-contacts"
          {...this.props}
          onUpdate={this.updateList}
          required={this.props.required}
          onError={this.props.onError}
          scrollIntoView={this.props.scrollIntoView}
        >
          <SubsequentContactItem
            attribute={attribute}
            required={this.props.required}
            bind
            name="Item"
            scrollIntoView={this.props.scrollIntoView}
          />
        </BranchCollection>
      </div>
    );
  }
}

SubsequentContacts.defaultProps = {
  name: 'SubsequentContacts',
  List: {},
  onUpdate: (queue) => {},
  onError: (value, arr) => arr,
};
